import { createFileRoute } from '@tanstack/react-router'
import { MarketingShell } from '@/components/admin/marketing/MarketingShell'
import { AdminEnrolmentSettings } from '@/components/admin/marketing/AdminEnrolmentSettings'

export const Route = createFileRoute('/admin/marketing/enrolment')({
  component: () => (
    <MarketingShell
      title="Enrolment"
      description="Share the link customers use to add your loyalty card to their phone — branded QR, live preview, one-tap sharing, and printable placards."
    >
      <AdminEnrolmentSettings />
    </MarketingShell>
  ),
})
